export const theme = {
  primary: "var(--color-primary)",
  secondary: "var(--color-secondary)",
  orange: "var(--color-mila_orange)",
  border: "var(--color-gray-200)",
  muted: "var(--color-gray-500)",
  text: "var(--color-gray-700)",
  surface: "var(--color-white)",
  subtle: "var(--color-gray-50)",
  success: "var(--color-emerald-600)",
  successBg: "var(--color-emerald-50)",
  danger: "var(--color-red-600)",
};

export const field = {
  border: `1px solid ${theme.border}`,
  borderRadius: 6,
  padding: 8,
  width: "100%",
  outline: "none",
  fontSize: 12,
  color: theme.text,
  backgroundColor: theme.surface,
};

export const primaryButton = {
  backgroundColor: theme.primary,
  color: theme.surface,
  border: "none",
  borderRadius: 6,
  padding: "6px 14px",
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: 12,
  cursor: "pointer",
};

export const ghostButton = {
  backgroundColor: theme.surface,
  color: theme.text,
  border: `1px solid ${theme.border}`,
  borderRadius: 6,
  padding: "6px 14px",
  fontSize: 12,
  cursor: "pointer",
};

export const label = {
  color: theme.muted,
  fontSize: 12,
};

export const spread = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
